"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateMenu = void 0;
var React = __importStar(require("react"));
var react_1 = require("react");
var react_2 = require("@chakra-ui/react");
var Icon_1 = require("../../Icon");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var pro_regular_svg_icons_1 = require("@fortawesome/pro-regular-svg-icons");
var useHeaderProps_1 = require("../hooks/useHeaderProps");
var colors_1 = require("../colors");
var color_1 = __importDefault(require("color"));
var NavMenu_1 = require("./_shared/NavMenu");
var MediaManager_1 = require("../../MediaManager");
var GuideLink = '/Guide/new';
var WikiLink = '/New/wiki';
var CategoryLink = '/New/topic';
var ItemLink = '/New/item';
var addTopicToLink = function (link, topic) {
    if (!topic)
        return link;
    return link.includes('Guide') ? "".concat(link, "/").concat(topic) : "".concat(link, "?topic=").concat(topic);
};
var CreateMenu = function (_a) {
    var _b;
    var toast = _a.toast;
    var _c = (0, useHeaderProps_1.useHeaderProps)(), colorSet = _c.colorSet, currentTopic = _c.currentTopic, _js = _c._js;
    var _d = (0, react_2.useDisclosure)(), onOpen = _d.onOpen, isOpen = _d.isOpen, onClose = _d.onClose;
    var backgroundColor = (_b = colorSet === null || colorSet === void 0 ? void 0 : colorSet.accent2) !== null && _b !== void 0 ? _b : colors_1.DEFAULT_ACCENT_COLOR_2;
    var _e = (0, react_1.useMemo)(function () {
        var base = new color_1.default(backgroundColor);
        var textColor = base.isLight() ? 'black' : 'white';
        var shadowColor = base.isLight()
            ? base.lighten(0.1).hex().toString()
            : base.darken(0.1).hex().toString();
        return { textColor: textColor, shadowColor: shadowColor };
    }, [backgroundColor]), textColor = _e.textColor, shadowColor = _e.shadowColor;
    var breakpoint = (0, react_2.useBreakpointValue)({ base: 'base', md: 'md', fallback: 'md' }, { ssr: false });
    var buttonStyle = {
        m: 1,
        p: 2,
        ml: 3,
        backgroundColor: backgroundColor,
        color: textColor,
        _hover: { backgroundColor: shadowColor },
        _expanded: { backgroundColor: shadowColor },
        variant: 'solid',
    };
    var links = (0, react_1.useMemo)(function () {
        var topic = currentTopic !== null && currentTopic !== void 0 ? currentTopic : '';
        return {
            guide: addTopicToLink(GuideLink, topic),
            wiki: addTopicToLink(WikiLink, topic),
            category: addTopicToLink(CategoryLink, topic),
            item: addTopicToLink(ItemLink, topic),
        };
    }, [currentTopic]);
    var featureId = 'header_create_menu_button';
    return (React.createElement(React.Fragment, null,
        React.createElement(NavMenu_1.NavMenu, null,
            breakpoint === 'base' ? (React.createElement(react_2.MenuButton, __assign({ h: 9, as: react_2.Button }, buttonStyle, { "data-feature-id": featureId }),
                React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faPlus, "data-testid": "plus-icon" }))) : (React.createElement(react_2.MenuButton, __assign({ h: 9, as: react_2.Button, "data-feature-id": featureId, rightIcon: React.createElement(Icon_1.Icon, { type: pro_solid_svg_icons_1.faCaretDown }) }, buttonStyle, { minWidth: "88px", p: "2" }), _js('Create'))),
            React.createElement(NavMenu_1.NavMenuList, null,
                React.createElement(MenuOption, { icon: pro_regular_svg_icons_1.faFileAlt, text: _js('New Guide'), href: links.guide, dataFeatureId: "header_create_menu_new_guide" }),
                React.createElement(MenuOption, { icon: pro_regular_svg_icons_1.faFileWord, text: _js('New Wiki'), href: links.wiki, dataFeatureId: "header_create_menu_new_wiki" }),
                React.createElement(MenuOption, { icon: pro_regular_svg_icons_1.faSitemap, text: _js('New Category'), href: links.category, dataFeatureId: "header_create_menu_new_category" }),
                React.createElement(MenuOption, { icon: pro_regular_svg_icons_1.faWrench, text: _js('New Item'), href: links.item, dataFeatureId: "header_create_menu_new_item" }),
                React.createElement(MenuOption, { icon: pro_regular_svg_icons_1.faCamera, text: _js('Media'), dataFeatureId: "header_open_media_manager", onClick: onOpen }))),
        React.createElement(MediaManager_1.MediaLibrary, { isOpen: isOpen, onClose: onClose, _js: _js, openInUploadView: true, toast: toast })));
};
exports.CreateMenu = CreateMenu;
var MenuOption = function (_a) {
    var icon = _a.icon, text = _a.text, href = _a.href, dataFeatureId = _a.dataFeatureId, onClick = _a.onClick;
    var LinkComponent = (0, useHeaderProps_1.useHeaderProps)().LinkComponent;
    return (React.createElement(React.Fragment, null, href ? (React.createElement(LinkComponent, { href: href, _hover: { textDecoration: 'none' } },
        React.createElement(react_2.MenuItem, { px: 4, py: 3, "data-feature-id": dataFeatureId },
            React.createElement(react_2.Flex, { align: "center", gap: 2 },
                React.createElement(Icon_1.Icon, { type: icon }),
                text)))) : (React.createElement(react_2.MenuItem, { px: 4, py: 3, "data-feature-id": dataFeatureId, onClick: onClick },
        React.createElement(react_2.Flex, { align: "center", gap: 2 },
            React.createElement(Icon_1.Icon, { type: icon }),
            text)))));
};
